import React, { Component } from 'react';
import PropTypes from 'prop-types';
import {
  Row,
  Col,
  Button,
  Form,
  Input,
  TimePicker,
  Upload,
  Checkbox,
  Select,
  InputNumber,
} from 'antd';

import moment from 'moment';
import get from 'lodash/get';
import CallbackModal from 'components/CallbackModal';
import { formatDateTimeDetailWib } from 'shared/utils/StringUtil';
import { handleUpload } from 'shared/utils/FilesUtil';

import { regexPattern } from 'shared/constant';

import PACKAGE_TYPE from '../../constant/PackageType';
import { ETA_UNIT } from '../../constant/DeliveryDefaultVar';
import text from './PartnerEdit.translation';

import './PartnerEdit.style.less';

const { TextArea } = Input;
const { Option } = Select;

class PartnerEditForm extends Component {
  constructor(props) {
    super(props);
    this.state = {
      formValues: {},
      logo: get(props, 'data.logo'),
      services: get(props, 'data.services'),
      editSuccessModalVisible: false,
    };
  }

  _fileUpload = key => (_file, base64) => {
    this.setState({ [key]: base64 });
    this.props.form.setFields({
      [key]: {
        value: base64,
      },
    });
  };

  _invalidImageCallback = key => () => {
    this.setState(
      prevState => ({
        [key]: get(prevState, key) || get(this.props.data, key),
      }),
      () => {
        const imgUrl = get(this.state, key) || get(this.props.data, key);
        if (imgUrl) {
          this.props.form.setFields({
            [key]: {
              value: imgUrl,
            },
          });
        } else {
          this.props.form.setFields({
            [key]: {
              value: null,
              errors: [new Error('Invalid file')],
            },
          });
        }
      },
    );
  };

  _renderPartnerLogoUpload = () => {
    const props = {
      name: 'partner-icon',
      accept: '.png',
      multiple: false,
      fileList: false,
      showUploadList: false,
      beforeUpload: () => false,
      onChange: handleUpload(
        {
          maxSize: 1000,
          maxDimension: {
            width: 1000,
            height: 1000,
          },
        },
        this._fileUpload('logo'),
        this._invalidImageCallback('logo'),
      ),
    };

    return (
      <div style={{ display: 'flex', flexDirection: 'column' }}>
        <img src={this.state.logo} alt="avatar" style={{ width: 200 }} />
        <span style={{ color: '#9b9b9b' }}>
          File format only .png with maximum size of 1Mb
        </span>
        <Upload {...props}>
          <span
            style={{
              cursor: 'pointer',
              color: '#108ee9',
              fontWeight: 600,
              paddingTop: 10,
            }}
          >
            Change
          </span>
        </Upload>
      </div>
    );
  };

  _renderPartnerServiceLogo = key => {
    const props = {
      name: 'service-icon',
      accept: '.png',
      multiple: false,
      fileList: false,
      showUploadList: false,
      beforeUpload: () => false,
      onChange: handleUpload(
        {
          maxSize: 500,
          maxDimension: {
            width: 500,
            height: 500,
          },
        },
        this._fileUpload(key),
        this._invalidImageCallback(key),
      ),
    };

    return (
      <div className="serviceLogo">
        <img src={get(this.state, key)} alt="avatar" />
        <Upload {...props}>
          <span
            style={{
              cursor: 'pointer',
              color: '#108ee9',
              fontWeight: 600,
              paddingTop: 10,
            }}
          >
            Change
          </span>
        </Upload>
      </div>
    );
  };

  renderBasicInfo = () => {
    const {
      form: { getFieldDecorator },
      onCancelForm,
    } = this.props;

    return (
      <div>
        <div className="step-title-container">
          Partner Basic Information Details
        </div>
        <div className="line-divider" />
        <Row className="form-wrapper" gutter={24}>
          <Col span={12}>
            <Form.Item required label="Partner Name">
              {getFieldDecorator('name', {
                initialValue: this.props.data.name,
                rules: [
                  {
                    required: true,
                    message: 'Please input partner name',
                  },
                ],
              })(
                <Input
                  type="text"
                  size="large"
                  placeholder="Enter partner name"
                />,
              )}
            </Form.Item>

            <Form.Item label="Partner ID">
              {getFieldDecorator('id', {
                initialValue: this.props.data.id,
              })(
                <Input
                  type="text"
                  size="large"
                  placeholder="Partner ID"
                  disabled
                />,
              )}
            </Form.Item>

            <Form.Item label="Partner Logo" required colon={false}>
              {getFieldDecorator('logo', {
                initialValue: this.props.data.logo,
                rules: [
                  {
                    required: true,
                    message: 'Partner Logo is required',
                  },
                ],
              })(this._renderPartnerLogoUpload())}
            </Form.Item>
          </Col>
          <Col span={12}>
            <Form.Item label="Created On">
              {getFieldDecorator('created_at', {
                initialValue: formatDateTimeDetailWib(
                  this.props.data.created_at,
                ),
              })(
                <Input
                  type="text"
                  size="large"
                  placeholder="Created On"
                  disabled
                />,
              )}
            </Form.Item>

            <Form.Item label="Updated On">
              {getFieldDecorator('updated_at', {
                initialValue: formatDateTimeDetailWib(
                  this.props.data.updated_at,
                ),
              })(
                <Input
                  type="text"
                  size="large"
                  placeholder="Updated On"
                  disabled
                />,
              )}
            </Form.Item>
          </Col>
        </Row>
        <div className="btn-container">
          <Button type="default" className="cancel-btn" onClick={onCancelForm}>
            Cancel
          </Button>
          <Button
            type="primary"
            className="btn margin-left-16"
            onClick={this.validateBasicInfo}
          >
            Next
          </Button>
        </div>
      </div>
    );
  };

  validateBasicInfo = () => {
    const {
      form: { validateFields },
    } = this.props;

    const fieldsToValidate = ['name', 'logo'];

    validateFields(fieldsToValidate, this.onValidateBasicInfo);
  };

  onValidateBasicInfo = (err, formValues) => {
    const { updatePartnerEditStep } = this.props;

    if (!err) {
      const newState = {
        ...this.state,
        formValues: {
          ...this.state.formValues,
          ...formValues,
        },
      };

      this.setState(newState);

      updatePartnerEditStep(2);
    }
  };

  renderServiceInfo = () => {
    const { data } = this.props;
    const services = get(data, 'services', []);

    return (
      <div>
        <div className="step-title-container">
          Service Basic Information Details
        </div>
        <div className="line-divider" />
        {services.map(this.renderServiceItem)}
        <div className="btn-container">
          <Button
            type="default"
            className="cancel-btn"
            onClick={this.onServiceInfoBack}
          >
            Back
          </Button>
          <Button
            type="primary"
            className="btn margin-left-16"
            onClick={this.validateServiceInfo}
          >
            Next
          </Button>
        </div>
      </div>
    );
  };

  renderServiceItem = (service, index, data) => {
    const {
      form: { getFieldDecorator, getFieldValue },
    } = this.props;

    let defaultTags = '';
    const serviceTags = get(service, 'tag') || [];
    serviceTags.forEach((tag, idx) => {
      defaultTags += idx === 0 ? tag : `,${tag}`;
    });

    const additionalFeeFormat = value => {
      if (value === undefined) {
        return '';
      }

      const numericFormat = value.toString().replace(/[^0-9]/g, '');
      const moneyFormat = numericFormat.replace(/\B(?=(\d{3})+(?!\d))/g, ',');
      return moneyFormat;
    };

    return (
      <div key={service.id}>
        <div className="service-item-container">
          <Row gutter={24}>
            <Col span={12}>
              <Form.Item label="Service Logo" required colon={false}>
                {getFieldDecorator(`services[${index}].logo`, {
                  initialValue: this.props.data.logo,
                  rules: [
                    {
                      required: true,
                      message: 'Partner Logo is required',
                    },
                  ],
                })(this._renderPartnerServiceLogo(`services[${index}].logo`))}
              </Form.Item>
            </Col>
            <Col span={12}>
              <Form.Item required label="Enable">
                {getFieldDecorator(`services[${index}].isActive`, {
                  initialValue: service.is_enable,
                })(
                  <div style={{ display: 'flex', flexDirection: 'column' }}>
                    <Checkbox
                      checked={getFieldValue(`services[${index}].isActive`)}
                    />
                  </div>,
                )}
              </Form.Item>
            </Col>
          </Row>
          <Row gutter={24}>
            <Col span={12}>
              <Form.Item required label="Service Name">
                {getFieldDecorator(`services[${index}].name`, {
                  initialValue: service.name,
                  rules: [
                    {
                      required: true,
                      message: 'Please input service name',
                    },
                  ],
                })(
                  <Input
                    type="text"
                    size="large"
                    placeholder="Enter service name"
                  />,
                )}
              </Form.Item>
            </Col>
            <Col span={12}>
              <Form.Item required label="Service Type">
                {getFieldDecorator(`services[${index}].type`, {
                  initialValue: service.type,
                  rules: [
                    {
                      required: true,
                      message: 'Please input service name',
                    },
                  ],
                })(
                  <Input
                    type="text"
                    size="large"
                    placeholder="Enter service typa"
                  />,
                )}
              </Form.Item>
            </Col>
          </Row>
          <Row gutter={24}>
            <Col span={6}>
              <Form.Item label="Service Tag">
                {getFieldDecorator(`services[${index}].tag`, {
                  initialValue: defaultTags,
                })(
                  <Input
                    type="text"
                    size="large"
                    placeholder="Enter service tag"
                  />,
                )}
              </Form.Item>
            </Col>
            <Col span={6}></Col>
            <Col span={6}>
              <Form.Item required label="Active Hour">
                {getFieldDecorator(`services[${index}].activeHour.min`, {
                  initialValue: moment(service.start_time, 'HH:mm:ss').isValid()
                    ? moment(service.start_time, 'HH:mm:ss')
                    : undefined,
                  rules: [
                    {
                      required: true,
                      message: 'Please input min active hour',
                    },
                  ],
                })(
                  <TimePicker
                    size="large"
                    format="HH:mm"
                    minuteStep={1}
                    className="active-hour-picker"
                    placeholder="From"
                  />,
                )}
              </Form.Item>
            </Col>
            <Col span={6}>
              <Form.Item required={false} label=" ">
                {getFieldDecorator(`services[${index}].activeHour.max`, {
                  initialValue: moment(service.end_time, 'HH:mm:ss').isValid()
                    ? moment(service.end_time, 'HH:mm:ss')
                    : undefined,
                  rules: [
                    {
                      required: true,
                      message: 'Please input max active hour',
                    },
                  ],
                })(
                  <TimePicker
                    size="large"
                    format="HH:mm"
                    minuteStep={1}
                    className="active-hour-picker"
                    placeholder="Until"
                  />,
                )}
              </Form.Item>
            </Col>
          </Row>
          <Row gutter={24}>
            <Col span={6}>
              <Form.Item required label="ETA Duration">
                {getFieldDecorator(`services[${index}].eta_duration`, {
                  initialValue: get(service, 'eta_duration', ''),
                  rules: [
                    {
                      required: true,
                      message: 'Please input service eta duration',
                    },
                  ],
                })(
                  <Input
                    type="text"
                    size="large"
                    placeholder="Enter ETA duration"
                  />,
                )}
              </Form.Item>
            </Col>
            <Col span={6}>
              <Form.Item required label="ETA Unit">
                {getFieldDecorator(`services[${index}].eta_unit`, {
                  initialValue: get(service, 'eta_unit', undefined),
                  rules: [
                    {
                      required: true,
                      message: 'Please select ETA Unit',
                    },
                  ],
                })(
                  <Select size="large" placeholder="Please select ETA Unit">
                    <Option value={ETA_UNIT.HOURS}>HOURS</Option>
                    <Option value={ETA_UNIT.DAYS}>DAYS</Option>
                  </Select>,
                )}
              </Form.Item>
            </Col>
            <Col span={12}>
              <Form.Item required label="Additional Fee">
                {getFieldDecorator(`services[${index}].additional_fee`, {
                  initialValue: get(service, 'additional_fee', undefined),
                  rules: [
                    {
                      required: true,
                      message: 'Enter Additional Fee',
                    },
                    {
                      pattern: regexPattern.NUMBER,
                      message: 'Enter Additional Fee',
                    },
                  ],
                })(
                  <InputNumber
                    size="large"
                    min={0}
                    precision={0}
                    placeholder="Enter Additional Fee"
                    formatter={additionalFeeFormat}
                    className="additional-fee"
                  />,
                )}
              </Form.Item>
            </Col>
          </Row>
        </div>
        {index !== data.length - 1 && <div className="line-divider" />}
      </div>
    );
  };

  onServiceInfoBack = () => {
    const { updatePartnerEditStep } = this.props;
    updatePartnerEditStep(1);
  };

  validateServiceInfo = () => {
    const {
      form: { validateFields },
      data,
    } = this.props;

    const services = get(data, 'services', []);
    const fieldsToValidate = [];
    for (let i = 0; i < services.length; i += 1) {
      fieldsToValidate.push(`services[${i}].logo`);
      fieldsToValidate.push(`services[${i}].isActive`);
      fieldsToValidate.push(`services[${i}].name`);
      fieldsToValidate.push(`services[${i}].type`);
      fieldsToValidate.push(`services[${i}].tag`);
      fieldsToValidate.push(`services[${i}].eta_duration`);
      fieldsToValidate.push(`services[${i}].eta_unit`);
      fieldsToValidate.push(`services[${i}].activeHour.max`);
      fieldsToValidate.push(`services[${i}].activeHour.min`);
      fieldsToValidate.push(`services[${i}].additional_fee`);
    }

    validateFields(fieldsToValidate, this.onValidateServiceInfo);
  };

  onValidateServiceInfo = (err, formValues) => {
    const { updatePartnerEditStep } = this.props;

    if (!err) {
      const newState = {
        ...this.state,
        formValues: {
          ...this.state.formValues,
          ...formValues,
        },
      };

      this.setState(newState);

      updatePartnerEditStep(3);
    }
  };

  renderPackageType = () => {
    const { data, loading } = this.props;
    const services = get(data, 'services', []);

    return (
      <div>
        <div className="step-title-container">
          Service Package Type Description
        </div>
        <div className="line-divider" />
        {services.map(this.renderPackageTypeItems)}
        <div className="btn-container">
          <Button
            type="default"
            className="cancel-btn"
            onClick={this.onPackageTypeBack}
          >
            Back
          </Button>
          <Button
            type="primary"
            className="btn margin-left-16"
            htmlType="submit"
            loading={loading}
          >
            Save
          </Button>
        </div>
      </div>
    );
  };

  getPackageByTypeName = (typeName, typeDescriptions) => {
    if (typeDescriptions.length > 0) {
      const index = typeDescriptions.findIndex(x => x.type === typeName);

      if (index > -1) {
        return typeDescriptions[index];
      }
    }

    return null;
  };

  renderPackageTypeItems = (service, index, data) => {
    const {
      form: { getFieldDecorator },
      intl: { formatMessage },
    } = this.props;

    const name = get(service, 'name', '');
    const type = get(service, 'type', '');
    const title = `Service Type: ${name} - ${type}`;

    const typeDescriptions = get(
      service,
      'additional_info.type_descriptions',
      [],
    );

    const documentType = this.getPackageByTypeName(
      PACKAGE_TYPE.DOCUMENT,
      typeDescriptions,
    );
    const docEn = get(documentType, 'description.en', '');
    const docId = get(documentType, 'description.id', '');
    const clothesType = this.getPackageByTypeName(
      PACKAGE_TYPE.CLOTHES,
      typeDescriptions,
    );
    const clothesEn = get(clothesType, 'description.en', '');
    const clothesId = get(clothesType, 'description.id', '');
    const foodType = this.getPackageByTypeName(
      PACKAGE_TYPE.FOOD,
      typeDescriptions,
    );
    const foodEn = get(foodType, 'description.en', '');
    const foodId = get(foodType, 'description.id', '');
    const groceriesType = this.getPackageByTypeName(
      PACKAGE_TYPE.GROCERIES,
      typeDescriptions,
    );
    const groceriesEn = get(groceriesType, 'description.en', '');
    const groceriesId = get(groceriesType, 'description.id', '');

    const placeholder = formatMessage(text.packageTypePlaceholder);

    return (
      <div className="package-type-container" key={service.id}>
        <div className="package-title">{title}</div>
        <div className="package-items">
          <Row gutter={24} className="package">
            <Col span={12}>
              <Form.Item label="Document - EN">
                {getFieldDecorator(`packageType[${index}].document.en`, {
                  initialValue: docEn,
                })(<TextArea rows={4} placeholder={placeholder} />)}
              </Form.Item>
            </Col>
            <Col span={12}>
              <Form.Item label="Document - ID">
                {getFieldDecorator(`packageType[${index}].document.id`, {
                  initialValue: docId,
                })(<TextArea rows={4} placeholder={placeholder} />)}
              </Form.Item>
            </Col>
          </Row>
          <Row gutter={24}>
            <Col span={12}>
              <Form.Item label="Clothes - EN">
                {getFieldDecorator(`packageType[${index}].clothes.en`, {
                  initialValue: clothesEn,
                })(<TextArea rows={4} placeholder={placeholder} />)}
              </Form.Item>
            </Col>
            <Col span={12}>
              <Form.Item label="Clothes - ID">
                {getFieldDecorator(`packageType[${index}].clothes.id`, {
                  initialValue: clothesId,
                })(<TextArea rows={4} placeholder={placeholder} />)}
              </Form.Item>
            </Col>
          </Row>
          <Row gutter={24}>
            <Col span={12}>
              <Form.Item label="Food & beverages">
                {getFieldDecorator(`packageType[${index}].food.en`, {
                  initialValue: foodEn,
                })(<TextArea rows={4} placeholder={placeholder} />)}
              </Form.Item>
            </Col>
            <Col span={12}>
              <Form.Item label="Food & Beverages - ID">
                {getFieldDecorator(`packageType[${index}].food.id`, {
                  initialValue: foodId,
                })(<TextArea rows={4} placeholder={placeholder} />)}
              </Form.Item>
            </Col>
          </Row>
          <Row gutter={24}>
            <Col span={12}>
              <Form.Item label="Fresh Groceries - EN">
                {getFieldDecorator(`packageType[${index}].groceries.en`, {
                  initialValue: groceriesEn,
                })(<TextArea rows={4} placeholder={placeholder} />)}
              </Form.Item>
            </Col>
            <Col span={12}>
              <Form.Item label="Fresh Groceries - ID">
                {getFieldDecorator(`packageType[${index}].groceries.id`, {
                  initialValue: groceriesId,
                })(<TextArea rows={4} placeholder={placeholder} />)}
              </Form.Item>
            </Col>
          </Row>
        </div>

        {index < data.length - 1 && <div className="line-divider" />}
      </div>
    );
  };

  onPackageTypeBack = () => {
    const { updatePartnerEditStep } = this.props;
    updatePartnerEditStep(2);
  };

  _handleSubmit = e => {
    e.preventDefault();
    const {
      form: { validateFields },
    } = this.props;

    validateFields(this.onValidate);
  };

  onValidate = (err, values) => {
    if (!err) {
      const { formValues } = this.state;

      const servicesData = this.props.data.services.map((service, index) => ({
        id: service.id,
        logo: get(this.state, `services[${index}].logo`),
        name: get(formValues, `services[${index}].name`),
        type: get(formValues, `services[${index}].type`),
        eta_duration: get(formValues, `services[${index}].eta_duration`),
        eta_unit: get(formValues, `services[${index}].eta_unit`),
        tag: get(formValues, `services[${index}].tag`, '').split(','),
        is_enable: get(formValues, `services[${index}].isActive`),
        start_time: moment(
          get(formValues, `services[${index}].activeHour.min`),
          'HH:mm:ss',
        ).format('HH:mm:ss'),
        end_time: moment(
          get(formValues, `services[${index}].activeHour.max`),
          'HH:mm:ss',
        ).format('HH:mm:ss'),
        additional_fee: get(formValues, `services[${index}].additional_fee`),
        additional_info: {
          type_descriptions: [
            {
              type: 'Document',
              description: {
                en: get(values, `packageType[${index}].document.en`, ''),
                id: get(values, `packageType[${index}].document.id`, ''),
              },
            },
            {
              type: 'Clothes',
              description: {
                en: get(values, `packageType[${index}].clothes.en`, ''),
                id: get(values, `packageType[${index}].clothes.id`, ''),
              },
            },
            {
              type: 'Food & Beverages',
              description: {
                en: get(values, `packageType[${index}].food.en`, ''),
                id: get(values, `packageType[${index}].food.id`, ''),
              },
            },
            {
              type: 'Fresh Groceries',
              description: {
                en: get(values, `packageType[${index}].groceries.en`, ''),
                id: get(values, `packageType[${index}].groceries.id`, ''),
              },
            },
          ],
        },
      }));

      const payload = {
        name: formValues.name,
        logo: this.state.logo,
        generate_new_key: false,
        services: servicesData,
      };

      this.props.updatePartner(
        this.props.data.id,
        payload,
        this.onEditPartnerSuccess,
      );
    }
  };

  onEditPartnerSuccess = () => {
    this.setState({
      editSuccessModalVisible: true,
    });
  };

  renderEditSuccessModal = () => (
    <CallbackModal
      onClose={this.onCloseEditSuccessModal}
      modalVisible={this.state.editSuccessModalVisible}
      type="success"
      description="Your changes has been saved for this partner"
    />
  );

  onCloseEditSuccessModal = () => {
    this.setState({
      editSuccessModalVisible: false,
    });

    const { onEditSuccess } = this.props;

    if (onEditSuccess) {
      onEditSuccess();
    }
  };

  render() {
    const { partnerEditStep } = this.props;

    return (
      <div>
        <Form colon={false} onSubmit={this._handleSubmit}>
          {partnerEditStep === 1 && this.renderBasicInfo()}
          {partnerEditStep === 2 && this.renderServiceInfo()}
          {partnerEditStep === 3 && this.renderPackageType()}
        </Form>
        {this.renderEditSuccessModal()}
      </div>
    );
  }
}

PartnerEditForm.propTypes = {
  intl: PropTypes.object,
  form: PropTypes.object,
  data: PropTypes.object,
  onBack: PropTypes.func,
  onCancelForm: PropTypes.func,
  updatePartnerEditStep: PropTypes.func,
  updatePartner: PropTypes.func,
  onEditSuccess: PropTypes.func,
  loading: PropTypes.bool,
  partnerEditStep: PropTypes.number,
};

export default PartnerEditForm;
